import axiosInstance from '@/lib/axios'; // Your configured axiosInstance instance



export async function getMatchInfo_4v4() {

    const response = await axiosInstance.get("/match/lobby/4v4");

    console.log(response.data)
    return response.data;
}




export async function creatMatchLobby() {

    const response = await axiosInstance.post("/match/lobby");

    console.log(response.data)
    return response.data;
}



export async function startFindingMatch() {

    const response = await axiosInstance.post("/match/lobby/team_queue");

    console.log(response.data)
    return response.data;
}



export async function fetchTeamQueueStarted() {

    const response = await axiosInstance.get("/match/lobby/team_queue/fetch");


    return response;
}



export async function canceFindingMatch() {

    const response = await axiosInstance.delete("/match/lobby/team_queue/cancel");
    return response

}




export async function leave_lobby_or_delete() {
    const response = await axiosInstance.delete("/match/lobby");
    console.log(response.data);
    return response.data;
}

